
import { Button } from "@/components/ui/button";
import FooterAr from "@/components/FooterAr";
import HeaderAr from "@/components/HeaderAr";
import { Link } from "wouter";
import { ChevronLeft } from "lucide-react";

const BusinessesAr = () => {
  return (
    <div className="min-h-screen bg-musicBlack" dir="rtl">
      <HeaderAr />
      <main className="pt-24">
        {/* Hero section */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-r from-musicBlack to-musicBlack/80"></div>
            <img 
              src="/lovable-uploads/3045f65a-010a-4a48-9281-3e6556c649c5.png" 
              alt="محترف موسيقى يؤدي" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="relative z-10 editorial-container">
            <div className="max-w-3xl">
              <h1 className="editorial-heading mb-4">للشركات</h1>
              <h2 className="editorial-subheading text-musicRed">استخدم الموسيقى بشكل قانوني. احم علامتك التجارية.</h2>
              <p className="editorial-body mb-6">
                كل إيقاع يحمل رؤية. تأكد من امتثال شركتك للوائح الإماراتية بينما تعزز تجربة عملائك 
                بالموسيقى المرخصة بشكل صحيح لمؤسستك التجارية.
              </p>
              <p className="editorial-body mb-8">
                احصل على ترخيص بالطريقة الصحيحة واحم شركتك.
              </p>
              <Button className="cta-button" size="lg">احصل على ترخيص</Button>
            </div>
          </div>
        </section>
        
        {/* How to License section */}
        <section className="py-24 bg-black">
          <div className="editorial-container">
            <h2 className="editorial-heading text-center mb-6">كيف أحصل على ترخيص؟</h2>
            <p className="editorial-body text-center max-w-3xl mx-auto mb-12">
              للبدء، اختر نوع شركتك أدناه أو اتصل على <span className="text-musicWhite font-bold">(+971) 50-123-4567</span> لمزيد من المعلومات.
            </p>
            
            <div className="business-type-grid">
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1514933651103-005eec06c04b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="بار أو مطعم أو مصنع جعة" />
                <div className="business-type-content">
                  <h3 className="business-type-title">بار أو مطعم أو مصنع جعة</h3>
                  <Link to="/ar/license/restaurant" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="نادي لياقة" />
                <div className="business-type-content">
                  <h3 className="business-type-title">نادي لياقة</h3>
                  <Link to="/ar/license/fitness" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1460317442991-0ec209397118?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="مجتمع سكني" />
                <div className="business-type-content">
                  <h3 className="business-type-title">مجتمع سكني</h3>
                  <Link to="/ar/license/residential" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="منشأة صحية" />
                <div className="business-type-content">
                  <h3 className="business-type-title">منشأة صحية</h3>
                  <Link to="/ar/license/healthcare" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1593784991095-a205069470b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="تلفزيون" />
                <div className="business-type-content">
                  <h3 className="business-type-title">تلفزيون</h3>
                  <Link to="/ar/license/television" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="راديو" />
                <div className="business-type-content">
                  <h3 className="business-type-title">راديو</h3>
                  <Link to="/ar/license/radio" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1601972599720-36938d4ecd31?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="موقع إلكتروني أو تطبيق جوال" />
                <div className="business-type-content">
                  <h3 className="business-type-title">موقع إلكتروني أو تطبيق جوال</h3>
                  <Link to="/ar/license/digital" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
              
              <div className="business-type-item">
                <img src="https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80" alt="تجارة تجزئة" />
                <div className="business-type-content">
                  <h3 className="business-type-title">تجارة تجزئة</h3>
                  <Link to="/ar/license/retail" className="business-type-button">
                    اعرف المزيد
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Don't see your type? */}
        <section className="py-24 bg-gradient-to-b from-black to-musicBlack">
          <div className="editorial-container">
            <div className="bg-musicBlack/70 border border-musicGrey/20 rounded-lg p-12 text-center">
              <h2 className="editorial-heading mb-4">لا ترى نوع شركتك هنا؟</h2>
              <p className="editorial-body max-w-2xl mx-auto mb-8">
                أمة الموسيقى تقدم أكثر من 60 ترخيص موسيقى مختلف لتناسب احتياجات شركتك.
                اطلع على قائمتنا الكاملة من التراخيص والأسعار ونماذج التقارير.
              </p>
              <Button className="cta-button" size="lg">عرض جميع التراخيص</Button>
            </div>
          </div>
        </section>
        
        {/* Fee Calculator Preview */}
        <section className="py-24 bg-gradient-to-b from-black to-musicBlack">
          <div className="editorial-container">
            <div className="text-center mb-12">
              <h2 className="editorial-heading mb-4">حاسبة رسوم الترخيص</h2>
              <p className="editorial-body max-w-2xl mx-auto">
                تعتمد رسوم الترخيص على نوع مؤسستك وحجمها وكيفية استخدامك للموسيقى. 
                استخدم حاسبتنا للحصول على تقدير فوري.
              </p>
            </div>
            
            <div className="bg-musicBlack border border-musicGrey/20 rounded-lg p-8 max-w-2xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div>
                  <label className="block text-musicWhite font-medium mb-2">نوع المؤسسة</label>
                  <select className="w-full bg-black border border-musicGrey/30 rounded-md p-3 text-musicWhite">
                    <option>مقهى/مطعم</option>
                    <option>متجر تجزئة</option>
                    <option>نادي رياضي/مركز لياقة</option>
                    <option>صالون/سبا</option>
                    <option>فندق</option>
                    <option>مركز تسوق</option>
                  </select>
                </div>
                <div>
                  <label className="block text-musicWhite font-medium mb-2">حجم المؤسسة (متر مربع)</label>
                  <select className="w-full bg-black border border-musicGrey/30 rounded-md p-3 text-musicWhite">
                    <option>أقل من 100 متر مربع</option>
                    <option>100-200 متر مربع</option>
                    <option>200-500 متر مربع</option>
                    <option>500-1000 متر مربع</option>
                    <option>أكثر من 1000 متر مربع</option>
                  </select>
                </div>
                <div>
                  <label className="block text-musicWhite font-medium mb-2">استخدام الموسيقى</label>
                  <select className="w-full bg-black border border-musicGrey/30 rounded-md p-3 text-musicWhite">
                    <option>موسيقى خلفية فقط</option>
                    <option>فعاليات موسيقى حية</option>
                    <option>عروض دي جي</option>
                    <option>مؤسسة تركز على الموسيقى</option>
                  </select>
                </div>
                <div>
                  <label className="block text-musicWhite font-medium mb-2">مدة الترخيص</label>
                  <select className="w-full bg-black border border-musicGrey/30 rounded-md p-3 text-musicWhite">
                    <option>سنة واحدة</option>
                    <option>سنتان</option>
                    <option>ثلاث سنوات</option>
                  </select>
                </div>
              </div>
              
              <div className="border-t border-musicGrey/20 pt-6 flex justify-between items-center">
                <div>
                  <p className="text-musicGrey">الرسوم السنوية المقدرة:</p>
                  <p className="font-serif text-2xl font-bold text-musicWhite">5,000 درهم</p>
                </div>
                <Button className="cta-button">ابدأ الترخيص</Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterAr />
    </div>
  );
};

export default BusinessesAr;
